import { IconSVG } from '../types';

export const Restart = ({ size, style }: IconSVG) => (
  <svg xmlns="http://www.w3.org/2000/svg" 
    width={size}
    height={size}
    style={style}
    fill="none" 
    viewBox="0 0 24 24"
  >
    <path
      fill="currentColor"
      d="M10.146 20.862a8.07 8.07 0 0 1-4.218-2.922q-1.631-2.148-1.631-4.928 0-1.389.45-2.655Q5.2 9.09 6.02 8.02q.3-.378.783-.396t.868.366q.293.292.312.726a1.27 1.27 0 0 1-.263.819 5.9 5.9 0 0 0-.85 1.628 5.7 5.7 0 0 0-.298 1.848q0 1.971 1.14 3.52a5.8 5.8 0 0 0 2.948 2.136q.367.123.604.434.236.312.236.672 0 .585-.407.916-.407.333-.947.172m4.708 0q-.54.16-.947-.181-.407-.342-.407-.926 0-.336.236-.65.237-.314.604-.437a6 6 0 0 0 2.946-2.151q1.142-1.54 1.142-3.505 0-2.434-1.687-4.154T12.626 7.09h-.1l.407.406q.293.293.293.733a1 1 0 0 1-.293.733 1 1 0 0 1-.733.293 1 1 0 0 1-.733-.293L9.21 6.706a1 1 0 0 1-.242-.37 1.2 1.2 0 0 1-.074-.425q0-.225.074-.426.075-.202.242-.37l2.256-2.262a1 1 0 0 1 .733-.292q.44 0 .733.292.293.294.293.733a1 1 0 0 1-.293.733l-.49.49h.105q3.415 0 5.785 2.39 2.37 2.392 2.37 5.813 0 2.761-1.63 4.916a8.1 8.1 0 0 1-4.219 2.934"
     />
  </svg>
);
